import { createSlice } from '@reduxjs/toolkit'

export const modalDeleteRecord = createSlice({
  name: 'modalDeleteRecord',
  initialState: { showModal: false },
  reducers: {
    setStateModal: (state, action) => {
      state.showModal = action.payload
    },
  },
})

export const { setStateModal } = modalDeleteRecord.actions
export default modalDeleteRecord.reducer
